/**
 * Ticket: SL-710
 * JIRA: https://toolsvilla.atlassian.net/browse/SL-710
 * Description: Check Subscription Detail
 * Author: Ankit Nigam
 */
export const checkSubscription=(payload)=> {
    
 return {
    //'<50k': payload.data['<50k'] < 5 ? 5 - payload.data['<50k'] : 0,//Check if '<50k' leads available
    //'50k-100k': payload.data['50k-100k'] < 3 ? 3 - payload.data['50k-100k'] : 0,//Check if '50k-100k' leads available
    //'>100k': payload.data['>100k'] < 2 ? 2 - payload.data['>100k'] : 0,//Check if ''>100K'' leads available
    leads: payload.data['leads'] ,//Check if leads available
    isSubscribed: payload.data['isSubscribed'],
    subscription_end: payload.data?.subscription_end
   };
}